import React from "react";
import { ToastContainer } from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
import { SlidingTimeoutBar } from "../lib/components/SlidingTimeoutBar";
import "./ToastMessage.css";

function resolveToastType(action, type) {
  const normalizedAction = String(action ?? "")
    .trim()
    .toLowerCase();

  if (
    ["delete", "removed", "remove", "reject", "decline", "error"].includes(
      normalizedAction,
    )
  ) {
    return "danger";
  }

  if (
    [
      "add",
      "added",
      "create",
      "created",
      "update",
      "updated",
      "approve",
    ].includes(normalizedAction)
  ) {
    return "success";
  }

  if (["warn", "warning"].includes(normalizedAction)) {
    return "warning";
  }

  if (["info", "load", "loaded"].includes(normalizedAction)) {
    return "info";
  }

  return type || "info";
}

function ToastMessage({
  message,
  delay,
  show,
  handleToast,
  type,
  action,
  topOffset = "4.5rem",
  zIndex = 2000,
}) {
  const autoHideDelay = typeof delay === "number" ? delay : 5000;
  const resolvedType = resolveToastType(action, type);

  return (
    <div>
      <ToastContainer
        className="toast-message-container p-3"
        position={"top-end"}
        style={{
          top: topOffset,
          zIndex,
        }}
      >
        <Toast
          autohide
          bg={resolvedType}
          className="toast-message p-0"
          show={show}
          onClose={handleToast}
          delay={autoHideDelay}
        >
          <Toast.Body>{message}</Toast.Body>
          <SlidingTimeoutBar isActive={show} duration={autoHideDelay} />
        </Toast>
      </ToastContainer>
    </div>
  );
}

export default ToastMessage;
